export default {
  bot: 'Bot',
  agent: 'Atendente',
  status: 'Estado',
  ticketsCount: 'Tickets en atención',
  averageResponseTime: 'Tiempo medio de respuesta',
  averageAttendanceTime: 'Tiempo de atención',
};
